const CONFIG = {
  URL: "https://spiritmas2025-api.event-ku.com",
  TOKEN_VOTING: "eyJpZF9hZG1pbiI6IjEiLCJ0b2tlbiI6IkVpRkFpOHRacXNQMUg1NVNBbkIzMSIsInJvbGUiOiJzdXBlcl9hZG1pbiJ9.VUl-4JDz_sMd0FgNogvptkbCc8DwykIyLnO_ZF2oiow"
};

export default CONFIG;
